import Yearbooks from './Yearbooks'

export default Yearbooks
